import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api/student`;

export interface StudentDashboardData {
  admitCard: {
    name: string;
    rollNumber: string;
    class: string;
    section: string;
    examName: string;
    examDate: string;
    examCenter: string;
    examTime: string;
    photo?: string;
    signature?: string;
  };
  feeReceipt: {
    receiptNumber: string;
    date: string;
    studentName: string;
    rollNumber: string;
    class: string;
    section: string;
    items: Array<{
      description: string;
      amount: number;
    }>;
    totalAmount: number;
    amountInWords: string;
    paymentMode: string;
    paymentStatus: 'paid' | 'pending';
    dueDate: string;
  };
}

export const getStudentDashboardData = async (): Promise<StudentDashboardData> => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    throw new Error('No authentication token found');
  }

  const response = await axios.get<StudentDashboardData>(`${API_URL}/dashboard`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  
  return response.data;
}; 